import React, { Component } from 'react';
import '../ImprovingTabs.css';
import _ from 'lodash';

class ImprovingTabsInputs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    render() {
        
        return (
            <div className="alignCenter">
                <label>{this.props.name}</label>
                <input type="text" className="tabContentInput valuesinput" 
                value={this.props.value}
                onChange={(e) => this.props.onChange(e.target.value, this.props.type)} 
                onKeyPress={(e)=>{e.key == 'Enter' &&  this.props.onNewValueAdd(this.props.groupId, this.props.segmentId, this.props.type)}}
                />
                <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.props.onNewValueAdd(this.props.groupId, this.props.segmentId, this.props.type)}
                ></i>
            </div>
        )
    }
}
export default (ImprovingTabsInputs);



// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Improving/ImprovingTabs/ImprovingTabsInputs/ImprovingTabsInputs.jsx